export default __webpack_public_path__ + "static/page-bg-0779c686799fc33d4375e27b0d8fcbb4.jpg";